import React, { useCallback, useRef, useState } from 'react';
import { PageCard } from './PageCard';
import { CarouselDots } from './CarouselDots';
import type { VolumePage } from '../data/volumeOnePages';
type Props = {
  pages: VolumePage[];
  onOpen: (index: number) => void;
};

/** One card at ~80% width with the next one peeking. Native swipe. Below md. */
export function LookInsideMobileCarousel({
  pages,
  onOpen
}: Props) {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const getStep = () => {
    const track = trackRef.current;
    const first = track?.children[0] as HTMLElement | undefined;
    if (!track || !first) return 0;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return first.offsetWidth + gap;
  };
  const onScroll = useCallback(() => {
    const track = trackRef.current;
    const step = getStep();
    if (!track || step === 0) return;
    setActive(Math.min(Math.round(track.scrollLeft / step), pages.length - 1));
  }, [pages.length]);
  const scrollToIndex = (i: number) => {
    trackRef.current?.scrollTo({
      left: i * getStep(),
      behavior: 'smooth'
    });
  };
  return <div className="md:hidden" data-id="element-162" data-mp="8ery843amb9z">
      <ul ref={trackRef} onScroll={onScroll} aria-label="Volume 1 pages" className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-[10%] pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-163" data-mp="8dgshyqaetg8">
        {pages.map((page, i) => <li key={page.src} className="w-[80vw] max-w-[360px] shrink-0 snap-center" data-id="element-164" data-mp="3qn0lsl7duqx5" data-mpi={i}>
            <figure data-id="element-165" data-mp="3lnnzc1kfblv3">
              <PageCard page={page} onOpen={() => onOpen(i)} data-id="element-166" data-mp="3lo7h9ia2qa94" />
              <figcaption className="mt-3 text-center font-sans text-[15px] leading-snug text-[#22303C]" data-id="element-167" data-mp="4ehgxva1vyft">
                {page.caption}
              </figcaption>
            </figure>
          </li>)}
      </ul>

      <CarouselDots count={pages.length} active={active} onSelect={scrollToIndex} labels={pages.map(p => p.caption)} data-id="element-168" data-mp="1fr1vfd2t3fk5" />
    </div>;
}